import { useEffect, useState } from 'react';
// material-ui
import { useTheme } from '@mui/material/styles';
import {
    Box,
    Grid,
    Typography,
} from '@mui/material';
// project imports
import useScriptRef from 'hooks/useScriptRef';
import AnimateButton from 'ui-component/extended/AnimateButton';

import { Link, useNavigate } from 'react-router-dom';
import { baseUrl } from 'store/baseurl';
import AuthWrapper1 from 'views/pages/authentication/AuthWrapper1';

const PlanCancelled = ({ ...others }) => {
    // const theme = useTheme();
    // const scriptedRef = useScriptRef();
    // const matchDownSM = useMediaQuery(theme.breakpoints.down('md'));
    // const customization = useSelector((state) => state.customization);
  const [errorMessage , setMessage] = useState("");
  const [IsLoading, setIsLoading] = useState(false);

    
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    // Get individual parameter values
    const key = urlParams.get('key');
    const [CancelledMessage, setCancelledMessage] = useState("Transaction Failed.");
    const navigate = useNavigate();

    useEffect(() => {
        // fetch(`${baseUrl}api/client/verifyaccount?key=${key}`, {
        //     method: 'Get',
        //     headers: {
        //         'Accept': 'application/json',
        //         'Content-Type': 'application/json',
        //     },
        // }).then(response => {
        //     console.log(response);
        //     if (!response.ok) {
        //         throw new Error('Network response was not ok');
        //     }
        //     return response.json();
        // })
        //     .then(apiData => {
        //         //setData(apiData);
        //         console.log(apiData);
        //         localStorage.setItem("userdata", apiData);
        //         if (apiData.success == true) {
        //             //   navigate("/dashboard");
        //             // setPlansData(apiData.data);
        //             setIsLoading(false);
        //         }
        //         else {
        //             setMessage(apiData.message);
        //         }
        //     })
        //     .catch(error => {
        //         console.log(error)
        //     })
    }, []);

    return (
        <>
            <AuthWrapper1>
                <Grid container direction="column" justifyContent="flex-end" sx={{ minHeight: '100vh' }}>
                    <Grid item xs={12}>
                        <Grid container justifyContent="center" alignItems="center" sx={{ minHeight: 'calc(100vh - 68px)' }}>
                            <Grid item sx={{ m: { xs: 1, sm: 3 }, mb: 0 }}>
                                <Grid item xs={12} container alignItems="center" justifyContent="center">
                                    {CancelledMessage && <Typography variant='h3' style={{ color: 'orange' }}>{CancelledMessage}</Typography>}
                                </Grid>
                                <Grid item xs={12} container alignItems="center" justifyContent="center">
                                    <Link to={"/showplan"}>
                                        <Typography>
                                            Go to Cart
                                        </Typography>
                                    </Link>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </AuthWrapper1>
        </>
    );
};

export default PlanCancelled;